// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zk-0";
export var tagInputDisabled = "_zk-1";